import { render, staticRenderFns } from "./custbillDtlbill.vue?vue&type=template&id=81782fce&scoped=true&"
import script from "./custbillDtlbill.vue?vue&type=script&lang=js&"
export * from "./custbillDtlbill.vue?vue&type=script&lang=js&"
import style0 from "./custbillDtlbill.vue?vue&type=style&index=0&id=81782fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81782fce",
  null
  
)

export default component.exports